export enum FeatureToggle {
  retailerContact = 'rt_ipp_retailer_contact',
}
